"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* after changing this file run 'yarn run webpack:build' */
/* tslint:disable */
require("../content/scss/vendor.scss");
require("hammer-timejs");
require("hammerjs");
// jhipster-needle-add-element-to-vendor - JHipster will add new menu items here
